import React from 'react'
import SubmitButton from '@components/Buttons/SubmitButton'
import urlUtils from '@services/urlUtils'

export default ({ label }) => {
    return (
        <SubmitButton
            onClick={() => urlUtils.redirectToPreviousUrl()}
            label={label}
            theme={'white'}
        />
    )
}
